<template>
  <div>wewe</div>
</template>

<script>
export default {
  name: "Default",
};
</script>

<style></style>
